import { render, staticRenderFns } from "./BillDeptSummary.vue?vue&type=template&id=1bad09d4&scoped=true"
import script from "./BillDeptSummary.vue?vue&type=script&lang=js"
export * from "./BillDeptSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bad09d4",
  null
  
)

export default component.exports